import { AxiosError } from 'axios';
import { QueryConfig, useQuery } from 'react-query';
import { __DEV__ } from '~src/config';

import { loadFolders } from '~src/services/api';
import { DbFolder } from '~src/types/db';
import { useProjectId } from '../useProjectId';

interface UseFoldersParams {
  favourites?: boolean;
  before?: number;
  search_name?: string;
  search_description?: string;
  as_admin?: boolean;
  after?: number;
  show_deleted?: boolean;
}
export const useFolders = (
  {
    favourites,
    before,
    search_name,
    search_description,
    as_admin,
    show_deleted,
    after,
  }: UseFoldersParams = {},
  queryConfig: QueryConfig<DbFolder[], AxiosError> & { enabled?: boolean } = {}
) => {
  const projectId = useProjectId();

  const { enabled, ...options } = queryConfig;
  // if enabled = undefined then enabled = true
  const enabledOverwrite = enabled || enabled === undefined;

  const foldersQuery = useQuery<DbFolder[], AxiosError>(
    [
      'folders',
      {
        projectId: String(projectId),
        favourites,
        before,
        search_name,
        search_description,
        as_admin,
        after,
        show_deleted,
      },
    ],
    loadFolders,
    {
      // refetch every 5 min
      refetchInterval: 5 * 60 * 1000,
      enabled: enabledOverwrite && projectId,
      refetchOnWindowFocus: !__DEV__,
      ...options,
    }
  );

  return foldersQuery;
};
